var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBirthdayCake({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1623740141389,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 963,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1014.448128 737.28c-21.504-13.312-44.032-26.624-63.488-41.984-58.368-45.056-135.168-45.056-193.536 0-67.584 52.224-80.896 52.224-145.408 1.024-60.416-47.104-135.168-47.104-197.632 0-64.512 50.176-78.848 50.176-142.336 1.024-64.512-50.176-138.24-49.152-201.728 1.024-15.36 12.288-32.768 22.528-51.2 34.816-21.504-164.864-17.408-211.968 126.976-224.256V384 259.072h144.384v248.832h147.456V258.048h144.384v249.856h148.48V257.024h144.384v233.472c53.248 27.648 95.232 49.152 137.216 70.656 2.048 59.392 2.048 117.76 2.048 176.128z",
    "p-id": 964
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.448128 1024H14.000128V818.176c35.84-21.504 70.656-38.912 101.376-61.44 38.912-28.672 74.752-27.648 111.616 1.024 89.088 68.608 141.312 68.608 228.352 1.024 38.912-30.72 75.776-30.72 115.712 1.024 82.944 66.56 140.288 65.536 224.256 1.024 43.008-33.792 72.704-30.72 119.808 1.024 30.72 20.48 66.56 32.768 99.328 48.128V1024zM522.928128 0c41.984 43.008 74.752 92.16 58.368 152.576-7.168 25.6-33.792 58.368-57.344 64.512-20.48 5.12-57.344-16.384-73.728-35.84-21.504-26.624-9.216-58.368 13.312-87.04 21.504-27.648 32.768-62.464 49.152-94.208h10.24zM819.888128 0c19.456 47.104 48.128 93.184 56.32 142.336s-37.888 90.112-76.8 78.848c-23.552-6.144-51.2-26.624-58.368-47.104-7.168-20.48 4.096-51.2 14.336-73.728 15.36-34.816 36.864-66.56 55.296-99.328 2.048-1.024 5.12-1.024 9.216-1.024zM235.184128 7.168c45.056 41.984 69.632 93.184 52.224 150.528-7.168 25.6-37.888 54.272-62.464 60.416-18.432 5.12-58.368-18.432-66.56-38.912-9.216-22.528 0-57.344 12.288-81.92 15.36-30.72 40.96-57.344 64.512-90.112z",
    "p-id": 965
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCake);
export default __webpack_public_path__ + "static/media/birthday-cake.29c2b26c.svg";
export { ForwardRef as ReactComponent };